import * as React from 'react';
import * as classNames from 'classnames';
import {RouteComponentProps, withRouter} from 'react-router';
import {Link} from 'react-router-dom';
import Thumbnail from '../Thumbnail/Thumbnail';
import {DashboardViewLayout} from '../../globals/Constants';
import ReviewOptionsContainer from '../ReviewOptions/ReviewOptionsContainer';
import Themeable from '../../types/Themeable';
import {MediaCard} from '@techsmith/tsc-cloud-style-guide';
import ContentTypeParser from '../../utils/ContentTypeParser/ContentTypeParser';
import ReviewRouterService from '../../services/ReviewRouterService/ReviewRouterService';
import TimeFormatter from '../../utils/TimeFormatter/TimeFormatter';
import ReviewerModel from '../../types/ReviewerModel';
import UserService from '../../services/UserService/UserService';
import Strings from '../../globals/Strings';

export default withRouter(({themeName, id, viewLayout, title, description, isOwner, thumbnailUrl, isInactive, mediaContentType, hasComments, createdDate, latestVersionNumber, history, mediaDuration, reviewOwner}: ReviewSummaryProps) => {
   const isListView = viewLayout === DashboardViewLayout.list;
   const isVideo = ContentTypeParser.getContentTypeIsVideo(mediaContentType);
   const classes = classNames('dashboard-review', {inactive: isInactive});
   const reviewUrl = ReviewRouterService.createCanonicalReviewUrl(id, latestVersionNumber);
   const onMediaClick = () => {
      history.push(reviewUrl);
   };
   const reviewOptions = <ReviewOptionsContainer themeName={themeName} reviewId={id} latestVersionNumber={latestVersionNumber} isOwner={isOwner} hasComments={hasComments} isListView={isListView} />;

   return (
      <li className={classes}>
         {isListView ? (
            <React.Fragment>
               <Link to={reviewUrl}>
                  <Thumbnail thumbnailUrl={thumbnailUrl}/>
               </Link>
               <div className="info">
                  <div className="review-text">
                     <Link to={reviewUrl}>
                        <div className="review-title">{title}</div>
                     </Link>
                     <div className="review-description">{description}</div>
                  </div>
                  {reviewOptions}
               </div>
            </React.Fragment>
         ) : (
            <MediaCard {...{
               mediaUrl: reviewUrl,
               onMediaClick: onMediaClick,
               mediaDate: createdDate.toLocaleDateString(),
               maxTitleLines: 1,
               title: title,
               thumbnailUrl: thumbnailUrl,
               themeName: themeName,
               controls: <React.Fragment><div className="version-badge" title={Strings.labels.versions.versionFull.replace('{param0}', latestVersionNumber.toString())}>{`V${latestVersionNumber}`}</div>{reviewOptions}</React.Fragment>,
               mediaDuration: isVideo && TimeFormatter.formatTime(mediaDuration) || '',
               ownerAvatarUrl: !isOwner && UserService.returnAvatarUrlIfNotDefault(reviewOwner.ProfileImageUrl) || '',
               ownerName: !isOwner && reviewOwner.DisplayName || '',
               ownerId: !isOwner && reviewOwner.Id || ''
            }}/>
         )}
      </li>
   );
});

export interface ReviewSummaryProps extends RouteComponentProps, Themeable {
   viewLayout: DashboardViewLayout;
   mediaContentType: string;
   title: string;
   description: string;
   id: string;
   isOwner: boolean;
   thumbnailUrl: string;
   isInactive: boolean;
   hasComments: boolean;
   latestVersionNumber: number;
   createdDate: Date;
   mediaDuration: number;
   reviewOwner: ReviewerModel;
}
